export default __webpack_public_path__ + "static/summer-send-off-sale-banner-mobile-463923f4a4c6fcd39a587318f9470091.webp";